
import { Link } from 'react-router-dom';
import { projectSummary } from '../../../mocks/roadmapData';

export default function RoadmapHero() {
  const overallProgress = Math.round(
    (projectSummary.completedTasks / projectSummary.totalTasks) * 100
  );

  const stats = [
    { label: '총 사업 기간', value: projectSummary.totalDuration, icon: 'ri-calendar-line', accent: 'from-teal-400 to-teal-600' },
    { label: '총 사업비', value: projectSummary.totalBudget, icon: 'ri-funds-line', accent: 'from-amber-400 to-amber-600' },
    { label: '예상 수입', value: projectSummary.totalRevenue, icon: 'ri-money-dollar-circle-line', accent: 'from-emerald-400 to-emerald-600' },
    { label: '전체 진행률', value: `${overallProgress}%`, icon: 'ri-pie-chart-line', accent: 'from-cyan-400 to-cyan-600' },
  ];

  return (
    <section className="relative pt-28 pb-20 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/d01a5bb7127e07cea37419faf7d50087.jpg"
          alt="종합 로드맵 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-gray-900/70 to-gray-900/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="mb-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-medium transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            메인 페이지로 돌아가기
          </Link>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-teal-300 px-4 py-2 rounded-full text-sm font-semibold mb-5 border border-white/10">
              <i className="ri-route-line text-base"></i>
              INTEGRATED PROJECT ROADMAP
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              프로젝트 종합 로드맵
            </h1>
            <p className="text-lg text-white/70 max-w-2xl leading-relaxed">
              토지 매입부터 입주까지, 서초동 프리미엄 복합개발 프로젝트의<br />
              전체 타임라인을 한눈에 확인합니다.
            </p>
          </div>
          <div className="flex items-center gap-3 text-sm text-white/50">
            <span>{projectSummary.startDate}</span>
            <div className="w-24 h-1 bg-white/20 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-teal-400 to-teal-500 rounded-full"
                style={{ width: `${overallProgress}%` }}
              ></div>
            </div>
            <span>{projectSummary.endDate}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-all cursor-default group"
            >
              <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${stat.accent} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${stat.icon} text-lg text-white`}></i>
              </div>
              <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-xs text-white/50 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
